import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { ModalLayout, MoreModalButtons } from "common/modal";
import { useTranslation } from "react-i18next";
import { Form, message } from "antd";

// GraphQL
import VNPAY_PAYMENT_RESULT from "graphql/queries/VnpayPaymentReturnUrl";
// Components
import { FormCard, CardTitle } from "../new_sign_up/SignUpStyle";

interface ResponseData {
  [key: string]: string;
}

const parseQueryParams = (queryString: string): ResponseData => {
  const params = new URLSearchParams(queryString);
  const responseData: ResponseData = {};
  for (const [key, value] of params.entries()) { // eslint-disable-line
    responseData[key] = value;
  }
  return responseData;
};

const parseOrderDesc = (orderDesc: any) => {
  try {
    const parsedDesc = JSON.parse(orderDesc.replace(/=>/g, ":"));
    return parsedDesc;
  } catch (error) {
    return orderDesc;
  }
};

type PaymentResultProps = {
  handleNext: () => void;
  setPaymentResult: (result: string) => void;
};

const PaymentResult = ({
  handleNext,
  setPaymentResult,
}: PaymentResultProps) => {
  const location = useLocation();
  const responseData = parseQueryParams(location.search);
  const { t } = useTranslation();

  const { loading, error, data } = useQuery(VNPAY_PAYMENT_RESULT, {
    variables: { responseData: JSON.stringify(responseData) },
    onCompleted: (completedData) => {
      const paymentResult = completedData?.vnpayPaymentReturnUrl?.result;
      setPaymentResult(paymentResult);
      if (paymentResult === "Success") {
        message.success(t("Thanh toán thành công!"));
      } else {
        message.error(t("Thanh toán thất bại! Đề nghị thử lại!"));
      }
    },
  });

  useEffect(() => {
    if (data) {
      handleNext();
    }
  }, [data, handleNext]);

  const { ModalRow, ModalCol } = ModalLayout;
  const { ButtonContainer, ModalButtonYellow } = MoreModalButtons;

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const paymentData = data?.vnpayPaymentReturnUrl;
  const orderDesc = paymentData?.orderDesc
    ? parseOrderDesc(paymentData.orderDesc)
    : {};

  return (
    <ModalRow gutter={16}>
      <ModalCol xs={24} sm={24} md={24} lg={8} style={{ textAlign: "left" }}>
        <CardTitle>{t("Payment Result").toUpperCase()}</CardTitle>
        <FormCard>
          <p>
            <strong>{t("Result")}:</strong> {paymentData.result}
          </p>
          <p>
            <strong>{t("Amount")}:</strong> {paymentData.amount}
          </p>
          <p>
            <strong>{t("Order ID")}:</strong> {paymentData.orderId}
          </p>
          <p>
            <strong>{t("Transaction No")}: </strong>
            {paymentData.transactionNo}
          </p>
          <p>
            <strong>{t("Response Code")}: </strong>
            {paymentData.responseCode}
          </p>
          {paymentData.message && (
            <p>
              <strong>{t("Message")}:</strong> {paymentData.message}
            </p>
          )}
          {orderDesc && (
            <div>
              <strong>{t("Order Description")}:</strong>
              <pre>{JSON.stringify(orderDesc, null, 2)}</pre>
            </div>
          )}
        </FormCard>
        <ButtonContainer
          xs={22}
          sm={22}
          md={24}
          lg={17}
          style={{ padding: "0" }}
          onClick={handleNext}
        >
          <Form.Item>
            <ModalButtonYellow>{t("Next")}</ModalButtonYellow>
          </Form.Item>
        </ButtonContainer>
      </ModalCol>
    </ModalRow>
  );
};

export default PaymentResult;
